import LoginView from "@/pages/authentication/views/LoginView";

export default function LoginMobileView() {
    return <LoginView mode="mobile" />;
}
